module.exports = __webpack_public_path__ + "img/logo-iteg.629da275.svg";